import * as React from 'react'
import { styled, css } from 'next-yak'

import * as plume from '@ulule/owl-kit-components/next'

import { footerBreakpoint } from './constants'

type AccordionSectionProps = {
  title: React.ReactNode
  id?: string
  children: React.ReactNode
  className?: string
}

function AccordionSectionComponent({
  title,
  id,
  children,
  className,
}: AccordionSectionProps): React.ReactElement<AccordionSectionProps> {
  return (
    <plume.Accordion id={id} title={title} className={className}>
      {children}
    </plume.Accordion>
  )
}

// important is required to handle prioritization over plume.accordion styles
const accordionSectionBreakpointStyle = css`
  border: 0 !important;
  padding: 0 !important;

  ${plume.styles.accordion.Title} {
    cursor: default;
    a {
      pointer-events: all;
      cursor: pointer;
    }
  }

  ${plume.styles.accordion.Content} {
    max-height: max-content;
  }

  ${plume.glyphs.Icon} {
    display: none !important;
  }

  ${plume.styles.accordion.Toggler}:checked ~ ${plume.glyphs.Icon} {
    display: none !important;
  }
`

export const AccordionSection = styled(AccordionSectionComponent)<{ $lang: string }>`
  ${plume.styles.accordion.Title} {
    a {
      color: inherit;
      pointer-events: none;
      text-decoration: none;
    }
  }

  ${({ $lang }) => {
    if (footerBreakpoint($lang) === 'laptop') {
      return css`
        @media screen and ${plume.BREAKPOINTS.LAPTOP} {
          ${accordionSectionBreakpointStyle};
        }
      `
    }
    if (footerBreakpoint($lang) === 'tablet') {
      return css`
        @media screen and ${plume.BREAKPOINTS.TABLET} {
          ${accordionSectionBreakpointStyle};
        }
      `
    }
  }};
`
